import { Badge, Box, Divider, Grid } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { useTheme } from '@mui/material'
import {
  TextBold,
  TextRegular,
  TextSemiBold
} from '../../../commonComponents/TextStyling'
import JobPost from '../../../commonComponents/JobPost'
import { useLocation, useNavigate } from 'react-router-dom'
import ImageComponent from '../../../commonComponents/ImageComponent'
import serverData from '../../../api/ServerData'
import { useDispatch } from 'react-redux'
import { logoutUser } from '../../../actions/loginActions'

export default function NewCompany () {
  const theme = useTheme()
  const location = useLocation()
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const [data, setData] = useState([])

  const [loading, setLoading] = useState(true)

  const company = location.state || {}

  useEffect(() => {
    getJobsPostedByEmployer()
  }, [])

  function getJobsPostedByEmployer () {
    serverData.getJobsPostedByEmployer(
      { employerId: company.employerId },
      result => {
        if (result.status) {
          setData(result?.response)
        }
        setLoading(false)
      },
      error => {
        setLoading(false)
        if (error.status === 401) {
          dispatch(logoutUser(navigate)) // eslint-disable-next-line
        }
      }
    )
  }

  return (
    <Grid container>
      <Grid item xs={12}>
        <Grid container>
          <Grid
            xs={7.5}
            item
            style={{
              display: 'flex'
            }}
          >
            <Grid
              container
              xs={12}
              style={{
                marginRight: '24px',
                backgroundColor: theme.palette.background.paper,
                borderRadius: '16px'
              }}
            >
              {company.companyImage && (
                <Grid item xs={12}>
                  <ImageComponent
                    alt='logo-description'
                    src={company.companyImage}
                    style={{
                      width: '100%',
                      height: 276,
                      borderRadius: '16px 16px 0px 0px'
                    }}
                  />
                </Grid>
              )}
              <Grid
                item
                xs={12}
                style={{ paddingTop: '24px', paddingLeft: '24px' }}
              >
                <TextBold style={{ fontSize: 16 }}>About Company</TextBold>
              </Grid>
              <Grid item xs={12} style={{ padding: '24px' }}>
                <TextRegular
                  style={{ fontSize: 16 }}
                  dangerouslySetInnerHTML={{
                    __html: company.aboutCompany
                  }}
                />
              </Grid>
            </Grid>
          </Grid>
          <Grid
            item
            xs={4.5}
            style={{
              background: theme.palette.background.paper,
              borderRadius: '16px',
              padding: '24px',
              height: 'min-content'
            }}
          >
            <Grid container>
              <Grid
                item
                style={{
                  display: 'flex',
                  border: `1px solid ${theme.palette.border.main}`,
                  width: '57px',
                  height: '56px',
                  borderRadius: '16px',
                  overflow: 'hidden',
                  padding: '4px',
                  objectFit: 'contain',
                  alignItems: 'center',
                  marginRight: '16px'
                }}
              >
                <ImageComponent
                  alt='company logo'
                  src={company.profilePicture}
                  style={{ width: '100%' }}
                />
              </Grid>
              <Grid item>
                <Grid item xs={12}>
                  <TextBold
                    style={{
                      fontSize: '18px'
                    }}
                  >
                    {company.companyname}
                  </TextBold>
                </Grid>

                <Grid item xs={12}>
                  <TextRegular
                    style={{
                      color: theme.palette.text.secondary
                    }}
                  >
                    {company.city}, {company.state}, {company.countryName}
                  </TextRegular>
                </Grid>
              </Grid>
            </Grid>
            {[
              { label: 'Size', value: company.size },
              { label: 'Website', value: company.websiteUrl },
              { label: 'Industry', value: company.industry },
              {
                label: 'Address',
                value: `${company.addressLine1} ${company.addressLine2},
              ${company.empCity}, ${company.empState},
              ${company.empCountry} ${company.empZipCode}`
              }
            ].map(item => (
              <Grid
                item
                xs={12}
                style={{
                  flexDirection: 'column',
                  display: 'flex',
                  marginTop: '16px  '
                }}
              >
                <TextBold style={{ fontSize: 16 }}>{item.label}:</TextBold>

                <TextRegular style={{ fontSize: 16 }}>{item.value}</TextRegular>
              </Grid>
            ))}
          </Grid>
        </Grid>
      </Grid>

      <Grid
        item
        xs={12}
        style={{ display: 'flex', marginTop: '32px', marginBottom: '24px' }}
      >
        <TextBold style={{ fontSize: '24px' }}>
          Jobs posted by {company.companyname}
        </TextBold>
        <Badge
          badgeContent={data?.length}
          color='primary'
          style={{ left: 12 }}
        />
      </Grid>
      <Grid item xs={12}>
        <JobPost data={data} loading={loading} />
      </Grid>
    </Grid>
  )
}
